/* eslint-disable react-hooks/rules-of-hooks */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useMemo } from 'react';
import moment from 'moment';
import useAsset from '../../../../hook/useAsset';
export function getChartWaveLabels(waves) {
    var constants = useAsset().constants;
    return useMemo(function() {
        return waves.reduce(function(acc, wave) {
            var isRunning = wave.attributes.status === constants.STATUS_ACTIVE;
            var waveDate = moment(wave.attributes.launch_date).format('M/D');
            var xLabel = isRunning ? waveDate + ' (running)' : waveDate;
            return _object_spread_props(_object_spread({}, acc), _define_property({}, wave.attributes.providable_id, xLabel));
        }, {});
    }, [
        waves,
        constants
    ]);
}
